<template>
    <div class="container">
        <div class="lucky-wheel">

            <!--活动主题-->
            <div class="lucky-title"></div>

            <!--抽奖盘-->
            <div v-if="!isOver" class="wheel">
              <div class="wheel-main">
                <div ref="draw-wheel" :class="{'wheel-pointer':true}"
                     @click="beginRotate()"></div>
                <div :class="{'wheel-bg':true,'enable-draw':!canDraw}" :style="rotateStyle">
                  <div class="prize-list">
                    <div class="prize-item"
                         v-for="(item,index) in prizeList"
                         :key="index"
                         :style="item.style">
                      <div :class="{'prize-pic':true,'hold-pic':item.id===14}">
                        <img :src="`static/luck-draw/prize/${item.icon}`"
                             v-if="item.id!=6"/>
                      </div>
                      <!--                                <div class="prize-type">{{item.name}}</div>-->
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!--活动结束-->
            <div v-else class="wheel panel">
              <div class="container">
                <over/>
              </div>
            </div>

            <!--我的中奖-->
            <div class="main">
              <div class="main-bg"></div>
              <div class="bg-p"></div>
              <div class="content">
                <div class="count">
                  <v-dialog v-model="ruleVisible" scrollable max-width="300px">
                    <template v-slot:activator="{ on, attrs }">
                      <span class="rule-span" v-bind="attrs" v-on="on">查看规则</span>
                    </template>
                    <rule :visible="ruleVisible"/>
                  </v-dialog>
                </div>
                <div class="count">单位名称：{{ user.data.msn }}</div>
                <div class="count">
                          <span>
                              当前可抽奖次数： {{ count }}
                          </span>
                  <v-dialog v-model="showTip" scrollable max-width="300px">
                    <template v-slot:activator="{ on, attrs }">
                                  <span v-bind="attrs" v-on="on"
                                        style="background: #fff;color: #000;width: 20px;height: 20px;display: inline-block;border-radius: 20px;">?</span>
                    </template>
                    <v-card style="color:#fff;">
                      <v-card-title style="background: #f36d56;color:#fff;">
                        <span style="font-size:15px;">仅展示最近20条获取记录</span>
                      </v-card-title>
                      <v-divider></v-divider>
                      <v-card-text style="height: 300px;background: #f36d56;">
                        <ul style="width: 100%;padding:0px!important;text-align: center;"
                            v-if="user.selfQtyRecord && user.selfQtyRecord.length>0">
                          <li v-for="(prize,index) in user.selfQtyRecord.slice(0,lotteryDraw)">
                            <span>{{ `订单` + prize.orderSn + '赠送：' + prize.qty + '次' }}</span>
                            <p>{{ moment(prize.createTime).format('YYYY-MM-DD HH:mm:ss') }}</p>
                          </li>
                          <el-button style="width: 100%;background: #f36d56;color:#fff;"
                                     v-if="lotteryDraw < user.selfPrize.length" @click="loadMore">加载更多
                          </el-button>
                          <el-button disabled style="width: 100%;background: #f36d56;color:#fff;" v-else>
                            没有更多了
                          </el-button>
                        </ul>
                        <p v-else>还没有中奖哦，快去抽奖吧~</p>
                      </v-card-text>
                    </v-card>
                  </v-dialog>
                </div>
                <div class="count">
                  <v-dialog v-model="dialog" scrollable max-width="640px">
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn color="primary"
                             dark
                             v-bind="attrs"
                             v-on="on">
                        我抽中的奖品
                      </v-btn>
                    </template>
                    <v-card style="color:#fff;">
                      <v-card-title style="background: #f36d56;color:#fff;">
                        <span style="font-size:15px;">仅展示最近20条抽奖记录</span>
                      </v-card-title>
                      <v-divider></v-divider>
                      <v-card-text style="height: 300px;background: #f36d56;">
                        <ul style="width: 100%;padding:0px!important;text-align: center;"
                            v-if="user.selfPrize && user.selfPrize.length>0">
                          <li v-for="(prize,index) in user.selfPrize.slice(0,lotteryDraw)">
                            <span>{{ `第[${ user.selfPrize.length - index }]次抽中的奖品： ` + prize.prizeName }}</span>
                            <p>{{ moment(prize.createTime).format('YYYY-MM-DD HH:mm:ss') }}</p>
                          </li>
                          <el-button style="width: 100%;background: #f36d56;color:#fff;"
                                     v-if="lotteryDraw < user.selfPrize.length" @click="loadMore">加载更多
                          </el-button>
                          <el-button disabled style="width: 100%;background: #f36d56;color:#fff;" v-else>
                            没有更多了
                          </el-button>
                        </ul>
                        <p v-else>还没有中奖哦，快去抽奖吧~</p>
                      </v-card-text>
                    </v-card>
                  </v-dialog>
                </div>
              </div>
            </div>

            <!--奖品展示区-->
            <div class="lucky-rule panel">
                <div class="container">
                    <scroll-seamless :data="prizeList.filter((v,i)=>i<=6)" :class-option="classOption"
                                     class="seamless-warp">
                        <div class="item" v-for="(item,index) in prizeList.filter(
                            prize=>prize.name.indexOf('谢谢惠顾') === -1 && prize.name.indexOf('谢谢参与') === -1)">
                            <img :src="`static/luck-draw/prize/${item.icon}`"/>
                            <span style="text-overflow: ellipsis;overflow-x: hidden;width: 80px;">{{ item.name }}</span>
                            <span>奖项数量:{{ item.virtualStock }}</span>
                        </div>
                    </scroll-seamless>
                </div>
            </div>

            <!--中奖名单-->
            <div class="drawer-result panel">
                <div class="container">
                    <scroll-seamless step="-1" :data="user.normalPrize" :class-option="classOption"
                                     class="seamless-warp">
                        <div class="item center" v-for="(item,index) in user.normalPrize.filter(
                            prize=>prize.prizeName.indexOf('谢谢惠顾') === -1 && prize.prizeName.indexOf('谢谢参与') === -1)">
                            <span class="user">{{ encry(item.msn) }}</span>
                            <span class="prize">{{ item.prizeName }}</span>
                            <span class="time">{{ moment(item.createTime).format('HH:mm') }}</span>
                        </div>
                    </scroll-seamless>
                </div>
            </div>

            <!--大奖名单-->
            <div class="special-drawer-result">
                <div class="container">
                    <scroll-seamless step="-1" :data="user.specialPrize" :class-option="classOption"
                                     class="seamless-warp">
                        <div class="item center" v-for="(item,index) in user.specialPrize">
                            <span>{{ encry(item.msn) }}</span>
                            <span class="prize">{{ item.prizeName }}</span>
                            <span class="time">{{ moment(item.createTime).format('YYYY-MM-DD HH:mm:ss') }}</span>
                        </div>
                    </scroll-seamless>
                </div>
            </div>
        </div>

        <div class="toast" v-show="prize">
            <div class="toast-container">
                <img :src="toastIcon" class="toast-picture"/>
                <div class="close" @click="closeToast()"></div>
                <div class="toast-title">{{ toastTitle }}</div>
                <div class="toast-btn">
                    <div class="toast-cancel" @click="closeToast">关闭</div>
                </div>
            </div>
        </div>
        <div class="toast-mask" v-show="prize"></div>
        <my-snack-bar :snackbar-content="snackbarOption.text"
                      :snackbar-show="snackbarOption.show"
                      :snackbar-hint-type="snackbarOption.hintType"
                      @close="handleSnackbarClose"></my-snack-bar>
    </div>
</template>
<script>
    import moment from 'moment'
    import request from '../../common/js/http'
    import {snackbarOption} from "@/common/js/snackbar";
    import MySnackBar from '@/components/Snackbar'
    import Rule from "../../views/lucky-drawer/components/Rule";
    import Over from "../../views/lucky-drawer/components/Over";
    import Toast from "@/components/Toast"
    import Mock from "mockjs";

    const CIRCLE_ANGLE = 360

    const config = {
        // 总旋转时间
        duration: 4000,
        // 旋转圈数
        circle: 8,
        mode: 'ease-in-out'
    }

    export default {
        name: 'LuckyDraw',
        data() {
            return {
                moment,
                count: 0, // 剩余抽奖次数
                duration: 3000, // 转盘旋转时间
                prizeList: [], // 奖品列表
                rotateAngle: 0, // 旋转角度
                lotteryDraw: 10,//显示记录
                index: 0,
                prize: null,
                snackbarOption,
                user: {
                    data: {
                        msn: ''
                    },
                    selfPrize: [],
                    normalPrize: [],
                    specialPrize: [],
                    selfQtyRecord: []
                },
                ruleVisible: false,
                userPrizeShow: false,
                dialog: false,
                canDraw: true,
                // 上次点击抽奖盘抽奖时间
                luckyDrawTime: 0,
                showTip: false,
                isOver: false //moment('2021-04-09').isAfter(moment()) && moment('2020-12-17').isAfter(moment())
            };
        },
        components: {
            Rule,
            Over,
            Toast,
            MySnackBar
        },
        created() {
            // 初始化一些值
            this.angleList = []
            // 是否正在旋转
            this.isRotating = false
            // 基本配置
            this.config = config

            // 获取奖品列表
            this.initPrizeList();
        },
        computed: {
            rotateStyle() {
                return `
        -webkit-transition: transform ${this.config.duration}ms ${this.config.mode};
        transition: transform ${this.config.duration}ms ${this.config.mode};
        -webkit-transform: rotate(${this.rotateAngle}deg);
            transform: rotate(${this.rotateAngle}deg);`
            },
            toastTitle() {
                return this.prize && this.prize.name !== '谢谢惠顾' && this.prize.name !== '谢谢参与' && (this.prize.level > 0 || this.prize.level === -1)
                    ? "恭喜您，获得" +
                    this.prize.name
                    : "谢谢惠顾";
            },
            toastIcon() {
                return this.prize && (this.prize.level > 0 || this.prize.level === -1)
                    ? require("../../../static/img/congratulation.png")
                    : require("../../../static/img/sorry.png");
            },
            classOption() {
                return {
                    hoverStop: false,
                    direction: 1,
                    step: 0.3, // 数值越大速度滚动越快
                }
            },
            startTime() {
                const startDate = moment(new Date(2022, 0, 19))
                const defaultDate = moment(new Date()).add(-14, 'day')
                if (startDate >= defaultDate) {
                    return startDate.format("YYYY-MM-DD")
                } else {
                    return defaultDate.format("YYYY-MM-DD")
                }
            }
        },
        methods: {
            loadMore: function () {
                this.lotteryDraw += 10;
            },
            encry(msn) {
                if (msn) {
                    let pre = msn.substr(0, 2)
                    let endWith = msn.substr(msn.length - 2, 2)
                    return pre + "***" + endWith
                }
                return Mock.Random.pick(['九江***药房', '南昌***药店', '赣州***药店', '乐平***药店', '德安***药店', '抚州***药房'])
            },
            initPrizeList() {
                // 这里可以发起请求，从服务端获取奖品列表
                // 这里使用模拟数据
                this.count = 0
                request.get('/luck-draw/ecs/ecs-prize/all')
                    .then(response => {
                        if (response.data.data != null && response.data.data.length > 0) {
                            this.prizeList = this.formatPrizeList(response.data.data)
                        } else {
                            this.callSnack(response.data.message, this.snackbarOption.typeEnum.error);
                            // this.isOver = true;
                        }
                    })
                // this.user.selfPrize.addAll()
            },
            // 格式化奖品列表，计算每个奖品的位置
            formatPrizeList(list) {
                // 记录每个奖的位置
                const angleList = []

                const l = list.length
                // 计算单个奖项所占的角度
                const average = CIRCLE_ANGLE / l

                const half = average / 2

                // 循环计算给每个奖项添加style属性
                list.forEach((item, i) => {

                    // 每个奖项旋转的位置为 当前 i * 平均值 + 平均值 / 2
                    const angle = -((i * average) + half)
                    // 增加 style
                    item.style = `-webkit-transform: rotate(${angle}deg);
                      transform: rotate(${angle}deg);`

                    // 记录每个奖项的角度范围
                    angleList.push((i * average) + half)
                })

                this.angleList = angleList

                return list
            },
            getPrizeIndex(prizeId) {
                return this.prizeList.findIndex(v => v.id === prizeId)
            },

            beginRotate() {
                if (!this.canDraw) {
                    // this.callSnack("请稍等")
                    return
                }

                // 次数校验
                if (!this.count || this.count === 0) {
                    this.callSnack("当前可抽奖次数为0", this.snackbarOption.typeEnum.error)
                    return
                }

                // 开始抽奖,这里这里向服务端发起请求，得到要获得的奖
                this.canDraw = false
                let start = new Date().getTime()
                request.post('/luck-draw/ecs/ecs-prize/draw/' + this.user.data.userName).then(response => {
                    // 可以返回下标，也可以返回奖品 id，通过查询 奖品列表，最终得到下标
                    if (response && response.data.data) {
                        // 获取下标
                        this.index = this.getPrizeIndex(response.data.data.prize.id)
                        // 开始旋转
                        this.rotating()

                        this.count = response.data.data.remainQty
                        this.$nextTick(() => {
                            let end = new Date().getTime()
                            let stick = 5000 - (end - start)
                            setTimeout(() => {
                                this.canDraw = true
                            }, stick)
                        })
                    } else {
                        this.callSnack(response.data.message, this.snackbarOption.typeEnum.error)
                        this.canDraw = true;
                    }
                }, error => {
                    this.callSnack(JSON.parse(error), this.snackbarOption.typeEnum.error)
                    this.canDraw = true;
                })
            },
            callSnack(text, hintType) {
                this.snackbarOption.show = true
                this.snackbarOption.text = text
                this.snackbarOption.hintType = hintType
            },
            random(max, min = 0) {
                return parseInt(Math.random() * (max - min + 1) + min)
            },
            rotating() {
                const {isRotating, angleList, config, rotateAngle, index} = this

                if (isRotating) return

                this.isRotating = true

                // 计算角度
                const angle =
                    // 初始角度
                    rotateAngle +
                    // 多旋转的圈数
                    config.circle * CIRCLE_ANGLE +
                    // 奖项的角度
                    angleList[index] -
                    (rotateAngle % CIRCLE_ANGLE)

                this.rotateAngle = angle

                // 旋转结束后，允许再次触发
                setTimeout(() => {
                    this.rotateOver()
                }, config.duration + 1000)
            },
            rotateOver() {
                this.isRotating = false

                this.prize = this.prizeList[this.index]

                console.log(this.prize, this.index)
            },
            //关闭弹窗
            closeToast() {
                this.prize = null;
            },
            loadCurrentUser() {
                let userName = this.$route.query.u
                if (userName) {
                    request.get(`/luck-draw/ecs-user/${userName}`)
                        .then(response => {
                            console.log(response)
                            this.user = response.data.data

                            this.count = this.user.data.prizeCount

                            if (!this.count) {
                                this.count = 0
                            }
                        }, reject => {
                            console.log(reject)
                        })
                } else {
                    this.callSnack("请您先登陆仁翔药购网后，再抽奖", this.snackbarOption.typeEnum.error)
                    window.history.back()
                }

            },
            handleSnackbarClose() {
                this.snackbarOption.show = false
                this.snackbarOption.text = ''
                this.snackbarOption.hintType = ''
            },
            onCloseRule() {
                this.ruleVisible = false
            }
        },
        mounted() {
            this.loadCurrentUser()
        }
    }
</script>
<style scoped lang="scss">
    .front {
        ul {
            li {
                list-style-type: none;
                width: 100%;
                margin: 5px auto;
            }
        }

        .container {
            width: 100%;
        }

        .lucky-wheel {
            width: 100%;
            background: rgb(252, 207, 133) url("../../../static/luck-draw/background/background.jpg") no-repeat;
            background-size: 100% 100%;
            //padding-top: 20px;
        }

        .lucky-title {
            width: 100%;
            height: 22.125rem;
            background: url("../../../static/luck-draw/background/active_title.jpg") no-repeat center top;
            background-size: 100%;
        }

        .panel {
            width: 100%;
            padding: 10px 10px;
            margin-top: 20px;
            color: #fff;
            position: relative;

            .container {
                display: flex;
                flex-flow: column nowrap;
                justify-content: flex-start;
                align-items: center;
                padding: 70px 0px 40px 0px;
                height: 100%;

                .item {
                    margin-top: 10px;
                    display: flex;
                    //flex-flow: column nowrap;
                    /*justify-content: space-around;*/
                    /*align-items: center;*/
                    /*width: 90%;*/
                    margin-left: auto;
                    margin-right: auto;
                    padding: 0px 12px;

                    &.center {
                        width: 100% !important;
                    }

                    img {
                        width: 50px;
                        height: 36px;
                        margin-right: 20px;
                    }

                    span {
                        margin-right: 5px;
                        display: inline-block;
                        text-align: left;

                        &.user {
                            width: 40%;
                        }

                        &.prize {
                            width: 50%;
                        }

                        &.time {
                            width: 10%;
                        }
                    }
                }
            }
        }

        .lucky-rule {
            height: 26.125rem;
            background: url("../../../static/luck-draw/background/prize_show.png") no-repeat center top;
            background-size: 100% 100%;
            background-origin: content-box;
            padding: 0px 15px;
            color: #fff;
        }

        .wheel {
            width: 100%;
            min-height: 30.125rem;
            background: url("../../../static/luck-draw/background/draw_area.png") no-repeat center top;
            background-size: 100% 100%;
            padding: 10px 10px;
            background-origin: content-box;
            margin-top: 20px;
            color: #fff;
            position: relative;

            .wheel-main {
                margin: 83px auto 0px auto;
                position: relative;
                width: 295px;
                height: 295px;

                .enable-draw {
                    pointer-events: none;
                }
            }
        }

        .drawer-result {
            width: 100%;
            min-height: 26.125rem;
            background: url("../../../static/luck-draw/background/win_prize.png") no-repeat center top;
            background-size: 100% 100%;
            background-origin: content-box;
            margin-top: 20px;
            color: #fff;
            position: relative;

            .drawer-result-container {
                margin: 35px auto 0px auto;
                position: relative;
                width: 295px;
                height: 295px;
            }
        }

        .special-drawer-result {
            width: 100%;
            min-height: 26.125rem;
            background: url("../../../static/luck-draw/background/special_win_prize.png") no-repeat center top;
            background-size: 100% 100%;
            background-origin: content-box;
            margin-top: 20px;
            color: #fff;
            position: relative;
            padding: 0px 10px;

            .container {
                display: flex;
                flex-flow: column nowrap;
                justify-content: flex-start;
                align-items: center;
                padding: 70px 0px 40px 0px;
                height: 100%;

                .item {
                    margin-top: 10px;
                    display: flex;
                    flex-flow: column nowrap;
                    justify-content: space-around;
                    align-items: center;
                    width: 90%;
                    margin-left: auto;
                    margin-right: auto;
                    padding: 0px 12px;

                    &.center {
                        width: 100% !important;
                    }

                    .prize, .time {
                        font-size: 12px;
                    }
                }
            }


            .special-drawer-result-container {
                margin: 35px auto 0px auto;
                position: relative;
                width: 295px;
                height: 295px;
            }
        }

        .wheel-bg {
            position: absolute;
            top: 0;
            left: 0;
            z-index: 1;
            width: 100%;
            height: 100%;
            background: url("../../assets/img/draw_wheel.png") no-repeat center top;
            background-size: 100%;
            color: #fff;
        }

        .wheel-pointer {
            position: absolute;
            top: 50%;
            left: 50%;
            z-index: 2;
            width: 85px;
            height: 85px;
            background: url("../../assets/img/draw_btn.png") no-repeat center top;
            background-size: 100%;
            transform: translate3d(-50%, -50%, 0);
        }

        .wheel-bg div {
            text-align: center;
        }

        .prize-list {
            width: 100%;
            height: 100%;
            position: relative;
        }

        .prize-list .prize-item {
            position: absolute;
            width: 95px;
            height: 150px;
            top: 0;
            left: 50%;
            margin-left: -47.5px;
            transform-origin: 50% 100%;
        }

        .prize-pic img {
            width: 4.0625rem;
            height: 3.2rem;
            margin-top: 2.5625rem;
        }

        .prize-count {
            font-size: 0.875rem;
        }

        .hold-pic {
            /*width: 4.0625rem;*/
            height: 2.5rem;
        }

        .prize-type {
            font-size: 0.75rem;
        }

        .main {
            position: relative;
            width: 100%;
            min-height: 7rem;
            /*background: rgb(243, 109, 86);*/
            padding-bottom: 1.6875rem;
            /*background: rgb(252, 207, 133) url("../../../static/img/715/background.png") no-repeat center bottom;*/
            background-size: 100%;
            /*margin-top: 20px;*/
        }

        .main-bg {
            width: 100%;
            height: 6.5625rem;
            position: absolute;
            top: -3.4375rem;
            left: 0;
            /*background: url("../../assets/img/luck_bg.png") no-repeat center top;*/
            background-size: 100%;
        }

        .bg-p {
            width: 100%;
            height: 2.95rem;
            /*background: rgb(252, 207, 133);*/
        }

        .content {
            position: absolute;
            top: 0.175rem;
            left: 0;
            /*background: rgb(243, 109, 86);*/
            width: 100%;
            height: 5.1875rem;
            font-size: 1.125rem;
            color: #ffeb39;
            /*padding-left: 6.75rem;*/
            text-align: center;

            .rule-span {
                text-decoration: underline;
            }
        }

        .content div {
            /*text-align: left;*/
        }


        .toast-mask {
            position: fixed;
            top: 0;
            left: 0;
            background: rgba(0, 0, 0, 0.6);
            z-index: 10000;
            width: 100%;
            height: 100%;
        }

        .toast {
            position: fixed;
            top: 50%;
            left: 50%;
            z-index: 20000;
            transform: translate(-50%, -50%);
            width: 15.4375rem;
            background: #fff;
            border-radius: 0.3125rem;
            padding: 0.3125rem;
            background-color: rgb(252, 244, 224);
        }

        .toast-container {
            position: relative;
            width: 100%;
            height: 100%;
            border: 1px dotted #fccc6e;
        }

        .toast-picture {
            position: absolute;
            top: -6.5rem;
            left: -1.5rem;
            width: 18.75rem;
            height: 8.5625rem;
        }

        .toast-pictrue-change {
            position: absolute;
            top: -1.5rem;
            left: -1.375rem;
            width: 17.5rem;
            height: 3.125rem;
        }

        .toast-title {
            padding: 2.8125rem 0;
            font-size: 18px;
            color: #fc7939;
            text-align: center;
        }

        .toast-btn {
            display: flex;
            align-items: center;
            justify-content: center;
            margin-bottom: 0.9375rem;
        }

        .toast-btn div {
            background-image: -moz-linear-gradient(
                            -18deg,
                            rgb(242, 148, 85) 0%,
                            rgb(252, 124, 88) 51%,
                            rgb(252, 124, 88) 99%
            );

            background-image: -ms-linear-gradient(
                            -18deg,
                            rgb(242, 148, 85) 0%,
                            rgb(252, 124, 88) 51%,
                            rgb(252, 124, 88) 99%
            );
            background-image: -webkit-linear-gradient(
                            -18deg,
                            rgb(242, 148, 85) 0%,
                            rgb(252, 124, 88) 51%,
                            rgb(252, 124, 88) 99%
            );
            box-shadow: 0px 4px 0px 0px rgba(174, 34, 5, 0.7);
            width: 4.6875rem;
            height: 1.875rem;
            border-radius: 1.875rem;
            text-align: center;
            line-height: 1.875rem;
            color: #fff;
        }

        .close {
            position: absolute;
            top: -0.9375rem;
            right: -0.9375rem;
            width: 2rem;
            height: 2rem;
            background: url("../../assets/img/close_store.png") no-repeat center top;
            background-size: 100%;
        }

        .seamless-warp {
            height: 24.125rem;
            overflow: hidden;
            width: 85%;
        }
    }

</style>



// WEBPACK FOOTER //
// luckywheel.vue?77390174